import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import { GetGamesListPayload, ExcludedGamesState } from '../models'

import { EXCLUDED_GAMES } from './api.routes'

const apiService: RestApiService = Container.get(RestApiService)

export const getAllGamesThunk = createAsyncThunk(
  ActionTypes.GET_ALL_GAMES,
  async (payload: GetGamesListPayload | any, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'GET',
        endpoint: EXCLUDED_GAMES.GAMES_LIST,
        queries: jsonToQueryString(payload),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await apiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getAllGamesExtraReducer = (
  builder: ActionReducerMapBuilder<ExcludedGamesState>,
) => {
  builder.addCase(getAllGamesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getAllGamesThunk.fulfilled, (state, { payload }) => {
    console.info('payload 2', payload, state)

    state.isLoading = false
    state.gamesList = payload
  })
}

export default getAllGamesExtraReducer
